import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';
import { ExportFormatterUtil } from './export-formatter.util';

/** Export mapper for Documentation > Correspondence (BRD §3.4.004 columns). */
export class CorrespondenceExportMapper {
  static toCsvExport(rows: any[], columns: any[], fileName: string): CsvExport {
    const exportColumns = this.getExportColumns(columns);
    const headers = exportColumns.map((col) => this.getLabel(col));
    const dataRows = rows.map((row) =>
      exportColumns.map((col) => this.getColumnValue(row, col)),
    );

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    columns: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const exportColumns = this.getExportColumns(columns);
    const headers = exportColumns.map((col) => this.getLabel(col));
    const dataRows = rows.map((row) =>
      exportColumns.map((col) => this.getColumnValue(row, col)),
    );

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static getExportColumns(columns: any[]): any[] {
    return columns.filter((col) => col.name && !col.fullRow);
  }

  private static getLabel(column: any): string {
    return column.label || column.name;
  }

  private static getColumnValue(row: any, column: any): any {
    if (!row || !column?.name) {
      return undefined;
    }

    const keys = Object.keys(row);
    const lowerKeyMap = keys.reduce(
      (acc, key) => {
        acc[key.toLowerCase()] = key;
        return acc;
      },
      {} as Record<string, string>,
    );

    const actualKey = lowerKeyMap[column.name.toLowerCase()];
    const value = actualKey ? row[actualKey] : undefined;

    if (column.format === 'd') {
      return ExportFormatterUtil.formatDate(value);
    }

    return value;
  }
}
